import { blacklistNames } from './blacklistNames';
export const isEmail = (email) => {
  const re = /\S+@\S+\.\S+/;

  return re.test(email);
};

export const isPhone = (email) => {
  // eslint-disable-next-line
  const re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

  return re.test(email);
};

export const formatPhone = (phone) => {
  const x = phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

  const value = !x[2] ? x[1] : `${x[1]}-${x[2]}${x[3] ? `-${x[3]}` : ''}`;

  return value;
};

export const formatPhoneParenthesis = (phone) => {
  if (!phone) {
    return phone;
  }
  const x = phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

  const value = !x[2] ? x[1] : `(${x[1]}) ${x[2]}${x[3] ? `-${x[3]}` : ''}`;

  return value;
};

export const formatSsn = (ssn) => {
  const x = ssn.replace(/\D/g, '').match(/(\d{0,3})(\d{0,2})(\d{0,4})/);

  const value = !x[2] ? x[1] : `${x[1]}-${x[2]}${x[3] ? `-${x[3]}` : ''}`;

  return value;
};
export const formatEin = (ein) => {
  const x = ein.replace(/\D/g, '').match(/(\d{0,2})(\d{0,7})/);

  const value = !x[2] ? x[1] : `${x[1]}-${x[2]}`;

  return value;
};

/**
 * Capitalize the beginning of each word
 * @param {*} string // must be a string
 */
export const capitalize = (string) => {
  return string
    .toLowerCase()
    .split(' ')
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');
};

/**
 * Depure the full name in order to trim the whitespaces and only return full name words.
 * @param string full_name must be a string otherwise it throws an error
 * @returns an Array with the fullname words.
 */
export function getFullNameArrayDepure(full_name) {
  if (typeof full_name === 'string' || full_name instanceof String) {
    const full_name_array = full_name.split(' ');
    if (!full_name_array.length) return [];
    return full_name_array.filter((item) => item.length > 0);
  } else {
    throw new Error('full_name should be of type string.');
  }
}

/**
 * Format first and last name from single string
 * @param string full_name must be a string otherwise it throws an error
 */

//  export const formatFirstLastName = (full_name) => {
//   const nameSplit = getFullNameArrayDepure(full_name);
//   const first_name = nameSplit[0];
//   let last_name = "";
//   if(nameSplit.length) {
//     nameSplit.shift();
//     last_name = nameSplit.join(' ');
//   } cual
//     return { first_name, last_name }
// };

export const formatFirstLastName = (full_name) => {
  const nameSplit = getFullNameArrayDepure(full_name);
  let last_name = '';

  if (nameSplit?.length > 1) {
    last_name = nameSplit?.pop();
  }

  const first_name = nameSplit?.join(' ');

  return { first_name, last_name };
};

/**
 * This function validates that a full name is a valid full name.
 * @param string full_name must be a string otherwise it throws an error
 * @returns true if the full name is valid or an error message if
 *  it isn't a valid full name.
 */
export const fullnameValidation = (full_name) => {
  if (!full_name) {
    return 'This field is required.';
  }
  const full_name_array = getFullNameArrayDepure(full_name);
  if (full_name_array.length < 2) return 'Please enter your full name.';
  return true;
};

export const formatE164 = (phoneNumber) => {
  // console.log("formatE164", phoneNumber);
  if (phoneNumber === undefined || phoneNumber?.length === 0) return '';
  phoneNumber = phoneNumber.replace(/[()]/g, ''); // Removes "(" and ")"

  const formattedNumber = phoneNumber?.replace(/[^0-9]/g, '');

  if (formattedNumber.length === 11) {
    return formattedNumber.replace(
      /(\d{1})(\d{3})(\d{3})(\d{4})/,
      '+$1 ($2)-$3-$4'
    );
  } else if (formattedNumber.length === 12) {
    return formattedNumber.replace(
      /(\d{2})(\d{3})(\d{3})(\d{4})/,
      '+$1 ($2) $3-$4'
    );
  }
  return phoneNumber;
};

export const formatE164Phones = (phoneNumber) => {
  if (phoneNumber === undefined || phoneNumber?.length === 0) return '';

  const formattedNumber = phoneNumber?.replace(/[^0-9]/g, '');

  if (formattedNumber.length === 11) {
    return formattedNumber.replace(
      /(\d{1})(\d{3})(\d{3})(\d{4})/,
      '+$1 ($2) $3-$4'
    );
  } else if (formattedNumber.length === 12) {
    return formattedNumber.replace(
      /(\d{2})(\d{3})(\d{3})(\d{4})/,
      '+$1 ($2) $3-$4'
    );
  }
  return phoneNumber;
};

export const validateFullName = (
  name,
  carrierName = null,
  disableBlacklist,
  context = null
) => {
  if (!name) return { isValid: true, message: 'This field is required.' };

  const fullName = name.trim();
  const set = new Set(blacklistNames);
  const keywordsRegex = /\blogistics\b|\btrucking\b|\bllc\b|\binc\b|\bcorp\b/i;

  if (keywordsRegex.test(fullName)) {
    return {
      isValid: false,
      message: 'Please enter your own first name, middle name, and last name.',
    };
  }

  if (!disableBlacklist && set.has(fullName.toLowerCase())) {
    //Context represent this.
    context?.$rollbar?.error('Full name included on the blacklist', {
      blacklistName: fullName,
    });
    return {
      isValid: false,
      message: 'Please enter your own first name, middle name, and last name.',
    };
  }

  if (fullName.length < 3 || fullName.length > 50) {
    return {
      isValid: false,
      message: 'Name should be between 3 and 50 characters.',
    };
  }

  if (!/^[a-zA-Z\s,'-]+$/.test(fullName)) {
    return { isValid: false, message: 'Name contains invalid characters.' };
  }

  if (fullName.trim().split(/\s+/).length < 2) {
    return {
      isValid: false,
      message: 'Please enter both first and last name.',
    };
  }

  if (/(.)\1{2,}/.test(fullName)) {
    return {
      isValid: false,
      message: 'Name contains consecutive repeated characters.',
    };
  }

  if (/\d|[^a-zA-Z\s,'-]/.test(fullName)) {
    return {
      isValid: false,
      message: 'Name should not contain numbers or special characters.',
    };
  }

  if (['asdf', 'qwerty', '1234', 'xxxx'].includes(fullName.toLowerCase())) {
    return {
      isValid: false,
      message: 'Name seems to be a placeholder, please enter a valid name.',
    };
  }

  const nameParts = fullName.trim().split(/\s+/);
  if (nameParts.some((part) => part.length < 2)) {
    return {
      isValid: false,
      message: 'Each part of the name should be at least 2 characters.',
    };
  }

  if (carrierName) {
    const carrierNameParts = carrierName.toLowerCase().split(/\s+/);
    if (
      carrierNameParts.some((part) => fullName.toLowerCase().includes(part))
    ) {
      return {
        isValid: true,
        alertMessage:
          'Please enter your own first name, middle name, and last name.',
      };
    }
  }

  return { isValid: true, message: 'Name is valid.' };
};

export const isDomain = (domain) => {
  const re =
    /^(?!:\/\/)([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]+\.[a-zA-Z]{2,11}?$/;
  return re.test(domain);
};
